import { TOGGLE_SIDEMENU, GET_SIDEMENU_STATUS } from '../constants/ActionTypes';

const initialState = {
  sideMenuOpen: false,
};

const toggleSideMenu = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SIDEMENU:
      return { ...state, sideMenuOpen: action.payload };
    case GET_SIDEMENU_STATUS:
      return { ...state };
    default:
      return state;
  }
};

export default toggleSideMenu;
